import { getFirstNameLastInitial } from 'utilities/string';

function getDisplayUserName (user: LP.productQuestionsAndAnswers.UserDetailProps) {

	let userName = 'A Shopper';

	if (user?.firstName && user?.lastName) {

		userName = getFirstNameLastInitial(user.firstName, user.lastName);

	} else if (user?.nickName) {

		userName = user.nickName;

	}

	return userName;

}

export default getDisplayUserName;
